import React from 'react';
import { ArticleType } from '@wix/answers-api';
import { Badge } from '@wix/design-system';
import { useTranslation } from '@wix/wix-i18n-config';
import { ArticleSearchResultDocumentType } from '../../../../types';
import { DATA_HOOKS } from '../../../../dataHooks';
export var SourceTypeTag = function (_a) {
    var _b;
    var type = _a.type, docType = _a.docType, academyType = _a.academyType;
    var t = useTranslation().t;
    var documentTypeMap = {
        isWixDocument: docType === ArticleSearchResultDocumentType.WIX_DOCS_ARTICLE,
        isCommunityPost: docType === ArticleSearchResultDocumentType.WIX_FORUM_TOPIC,
        isWixStudioAcademy: docType === ArticleSearchResultDocumentType.WIX_STUDIO_ACADEMY,
    };
    var ARTICLE_TYPE_LABELS = (_b = {},
        _b[ArticleType.FEATURE_REQUEST] = t('shared.feature.request.title'),
        _b[ArticleType.KNOWN_ISSUE] = t('shared.known.issue.title'),
        _b[ArticleType.ARTICLE] = t('shared.article.title'),
        _b[ArticleType.VIDEO] = t('shared.article.title'),
        _b);
    var getArticleTypeTitle = function () {
        if (documentTypeMap.isWixDocument) {
            return t('shared.search.results.document.title');
        }
        if (documentTypeMap.isCommunityPost) {
            return t('shared.search.results.community.forum.title');
        }
        if (documentTypeMap.isWixStudioAcademy && academyType) {
            return academyType;
        }
        if (type && type in ARTICLE_TYPE_LABELS) {
            return ARTICLE_TYPE_LABELS[type];
        }
        return t('shared.article.title');
    };
    return (React.createElement(Badge, { dataHook: DATA_HOOKS.SEARCH_RESULT_SOURCE_TYPE_TAG, size: "tiny", skin: "neutralLight", type: "solid" }, getArticleTypeTitle()));
};
//# sourceMappingURL=index.js.map